import { jsx as _jsx } from "react/jsx-runtime";
function CaretRight({ className, size = 24 }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { d: "M9.99976 6L15.9998 12L9.99976 18", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "square" }) }));
}
export default CaretRight;
